import api from './api';

export default {
  async getTemplates(params = {}) {
    const { data } = await api.get('/admin/session-templates', { params });
    return data;
  },

  async createTemplate(payload) {
    const { data } = await api.post('/admin/session-templates', payload);
    return data;
  },

  async getTemplate(id) {
    const { data } = await api.get(`/admin/session-templates/${id}`);
    return data;
  },

  async updateTemplate(id, payload) {
    const { data } = await api.patch(`/admin/session-templates/${id}`, payload);
    return data;
  },

  async publishTemplate(id) {
    const { data } = await api.post(`/admin/session-templates/${id}/publish`);
    return data;
  },

  async archiveTemplate(id) {
    const { data } = await api.post(`/admin/session-templates/${id}/archive`);
    return data;
  },

  async deleteTemplate(id) {
    const { data } = await api.delete(`/admin/session-templates/${id}`);
    return data;
  },

  // Localisation (US BO Sylvia) : créer en 1 langue, générer les autres, éditer.
  async getTranslations(id) {
    const { data } = await api.get(`/admin/session-templates/${id}/translations`);
    return data;
  },

  async localize(id, locales = null) {
    const { data } = await api.post(
      `/admin/session-templates/${id}/localize`,
      locales ? { locales } : {}
    );
    return data;
  },

  async saveTranslation(id, locale, payload) {
    const { data } = await api.put(
      `/admin/session-templates/${id}/translations/${locale}`,
      payload
    );
    return data;
  },
};
